import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "EmbeddedDashboard" }
const _hoisted_2 = ["token", "src", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("tableau-viz", {
      id: "tableauViz",
      token: _ctx.tableauJWT,
      src: _ctx.dashboardUrl,
      width: _ctx.dashboardWidth,
      height: _ctx.dashboardHeight,
      style: _normalizeStyle(`width: ${_ctx.dashboardWidth}px; height: ${_ctx.dashboardHeight}px;`)
    }, null, 12 /* STYLE, PROPS */, _hoisted_2)
  ]))
}